import { render, staticRenderFns } from "./Ideas.vue?vue&type=template&id=12c1fa65&scoped=true&"
import script from "./Ideas.vue?vue&type=script&lang=js&"
export * from "./Ideas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c1fa65",
  null
  
)

export default component.exports